import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
    fundList: [],
    fundTrendingList: [],
    fundCurrentPeriod: '1Y',
    fundCurrentUnitType: 'price',
    fundNav: [],
    fundPeriod: [],
    fundFilter: [],
    fundAmc: [],
    fundCategories: [],
    fundPagination: null,
    fundFollowing: [],
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
